export function getNavigationAndroidLink (name, latlng) {
  return `google.navigation:q=${latlng.lat},${latlng.lng}`
}

export function getNavigationIOSLink (name, position) {
  return `http://maps.apple.com/?daddr=${position.lat},${position.lng}`
}

export function getNavigationFallbackLink (name, position) {
  return `https://maps.google.com?daddr=${position.lat},${position.lng}`
}



// WEBPACK FOOTER //
// ./src/utils/NavigationLinks.js